import { render } from "./StaticSample.vue?vue&type=template&id=3030858e&scoped=true"
import script from "./StaticSample.vue?vue&type=script&lang=js"
export * from "./StaticSample.vue?vue&type=script&lang=js"

import "./StaticSample.vue?vue&type=style&index=0&id=3030858e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3030858e"]])

export default __exports__